export const sharedTileButtonClass = 'min-w-[44px]  text-size-body-sm';
